export default function(d) {
  return d;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-shape/src/identity.js
// module id = 983
// module chunks = 0